import gql from 'graphql-tag';

export default fields => gql`
mutation ($id: String!) {
    deleteChannel (input: { id: $id }) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Channels/DeleteMutation.js